import { render, staticRenderFns } from "./IconSvgGBANewsFeed.vue?vue&type=template&id=1477da13&scoped=true&"
import script from "./IconSvgGBANewsFeed.vue?vue&type=script&lang=js&"
export * from "./IconSvgGBANewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477da13",
  null
  
)

export default component.exports